import React from 'react'
import phone from '../../assets/phone.svg'
import message from '../../assets/message.svg'
import location from '../../assets/location.svg'
import BackToTop from '../BackToTop/BackToTop'

const Footer = () => {
    const menu = ['Home','About Us','Our Services','Contact Us']
    const aboutUs = ['Meet the team','Our goals','Our Mission']
    const services = ['Personal loans','Mortgage loans','Machinery loans','Cash points']
  return (
      <section className='bg-primary mt-[120px]'>
        <div className='container md:pl-[61px] md:pr-[57px] xl:pt-[121px] pb-[95px] xl:pb-[100px] px-[20px] xl:px-[37px] '>
            <div className='grid md:grid-cols-3 xl:grid-cols-6'>
                <div className='col-span-2 hidden xl:block text-white xl:pt-[172px]'>
                    <p className='text-[22px] leading-[28px]'>Kpoikpoimingi ltd</p>
                    <p className='xl:w-[347px] text-[16px] xl:mt-[23px] leading-[24px] tracking-[0.005em] '>Kpoikpoimingi limited is a Nigerian organization built on trust tailored to help  meet your financial goals because trust is a great determinant for business scuccess</p>
                </div>
                <div className='text-white'>
                    <p className='text-[22px] leading-[28px] mt-[56px] xl:mt-0 mb-[20px] xl:mb-[48px]'>Menu</p>
                    <ul>
                        {menu.map((item, i) => (
                            <li className='text-[14px] md:text-[16px] mb-[15px] xl:mb-[29px] leading-[20px] md:leading-[24px] tracking-[0.001em] md:tracking-[0.005em] hover:ml-5 duration-200 ease-linear ' key={i}>{item}</li>
                        ))}
                        </ul>
                </div>

                <div className='text-white'>
                    <p className='text-[22px] leading-[28px] mt-[46px] xl:mt-0 mb-[20px] xl:mb-[48px]'>About Us</p>
                    <ul>
                    {aboutUs.map((item, i) => (
                            <li className='text-[14px] md:text-[16px] mb-[15px] xl:mb-[29px] leading-[20px] md:leading-[24px] tracking-[0.001em] md:tracking-[0.005em] hover:ml-5 duration-200 ease-linear ' key={i}>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='text-white'>
                    <p className='text-[22px] leading-[28px] mt-[46px] xl:mt-0 mb-[20px] xl:mb-[48px]'>Our Sevices</p>
                    <ul>
                    {services.map((item, i) => (
                            <li className='text-[14px] md:text-[16px] mb-[15px]  xl:mb-[29px] leading-[20px] md:leading-[24px] tracking-[0.001em] md:tracking-[0.005em] hover:ml-5 duration-200 ease-linear ' key={i}>
                                {item}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className='text-white'>
                    <p className='text-[22px] leading-[28px] mt-[46px] xl:mt-0 mb-[20px] xl:mb-[48px]'>Contact Us</p>
                    <ul>
                            <li className='text-[14px] flex md:text-[16px] mb-[15px] xl:mb-[29px] leading-[20px] md:leading-[24px] tracking-[0.001em] md:tracking-[0.005em] hover:ml-5 duration-200 ease-linear '>
                                <img className='w-[16px] h-[20px] mr-[6px] ' src={message} alt="/" />
                                <p>Hello@gmail.com</p>
                            </li>
                            <li className='text-[14px] flex md:text-[16px] mb-[15px]  xl:mb-[29px] leading-[20px] md:leading-[24px] tracking-[0.001em] md:tracking-[0.005em] hover:ml-5 duration-200 ease-linear '>
                                <img className='w-[16px] h-[20px] mr-[6px] '  src={phone} alt="/" />
                                <p>+12345678901</p>
                            </li>
                            <li className='text-[14px] flex md:text-[16px] leading-[20px] md:leading-[24px] tracking-[0.001em] md:tracking-[0.005em] hover:ml-5 duration-200 ease-linear '>
                                <img className='w-[16px] h-[20px] mr-[6px] ' src={location} alt="/" />
                                <p>Abuja,Porthacourt</p>
                            </li>
                    </ul>
                </div>
            </div>
        </div>
        <BackToTop />
      </section>
    
  )     
}

export default Footer